import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import {
  EspaciosService,
  InformacionEspacio,
} from '../../../servicios/espacios.service';

@Component({
  selector: 'app-listar-espacios',
  templateUrl: './listar-espacios.component.html',
  styleUrls: ['./listar-espacios.component.scss'],
})
export class ListarEspaciosComponent implements OnInit {

  @Input() reservaEspacios: boolean;
  @Input() idEspacioSeleccionado: number;
  @Output() onIdEspacioSeleccionado = new EventEmitter();
  
  constructor(
    private router: Router,
    private espaciosService: EspaciosService
  ) {
  }
  
  opciones: string = 'assets/espacios/opciones.svg';
  
  espacios: Array<InformacionEspacio>;
  
  ngOnInit() {
    this.espaciosService.getEspacios(0).subscribe((data) => {
      this.espacios = data.data.lugares;
    });
  }

  handleEditar(id: number): void {
    this.router.navigate([`lugares/detalle-espacio/${id}`]);
  }

  seleccionarEspacio(espacio: InformacionEspacio) {
    this.onIdEspacioSeleccionado.emit(espacio.id);
  }
}
